import { Procedure } from "../model";

export class ProcedureSaveCommand{
    procedure: Procedure;

    constructor(procedure: Procedure){
        this.procedure = procedure;
    }
}